export default {
  container: provided => ({
    ...provided,
    width: '100%',
    maxWidth: '100%',
  }),
  control: provided => ({
    ...provided,
    border: '1px solid #c7cad6',
    borderRadius: 10,
    outline: 'none',
    boxShadow: 'none',
    width: '100%',
    height: 45,
    '&:hover': {
      boxShadow: 'none',
    },
  }),
  singleValue: provided => ({
    ...provided,
    color: 'black',
    fontSize: 14,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
    cursor: 'pointer',
    backgroundColor: 'var(--color-white)',
    color: 'black',
    '&:hover': {
      fontSize: 14,
      backgroundColor: 'var(--color-hover-overlay-primary)',
      color: 'var(--color-text-primary)',
    },
  }),
  menu: provided => ({
    ...provided,
    wordBreak: 'break-all',
    marginTop: 0,
  }),
  placeholder: provided => ({
    ...provided,
    fontSize: 14,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
}
